
import React from 'react';
import { Coins, AlertTriangle } from 'lucide-react';
import { useTokens } from '../../hooks/useTokens';
import { Button } from '../ui/button';

interface TokenBalanceProps {
  isCollapsed?: boolean;
  onPurchaseClick?: () => void;
}

const TokenBalance: React.FC<TokenBalanceProps> = ({ 
  isCollapsed = false, 
  onPurchaseClick 
}) => {
  const { tokenBalance, loading, isLowBalance } = useTokens();

  if (loading) {
    return (
      <div className={`${isCollapsed ? "px-2" : "px-8"} mb-3`}>
        <div className={`animate-pulse bg-muted rounded h-8 ${isCollapsed ? "w-8" : "w-full"}`}></div>
      </div>
    );
  }

  if (isCollapsed) {
    return (
      <div className="px-2 mb-3">
        <div 
          className={`flex items-center justify-center p-2 rounded-md cursor-pointer hover:bg-sidebar-accent ${
            isLowBalance() ? 'bg-orange-50 dark:bg-orange-950 border border-orange-200 dark:border-orange-800' : 'bg-sidebar'
          }`}
          onClick={onPurchaseClick}
          title={`${tokenBalance} tokens remaining`}
        >
          {isLowBalance() ? (
            <AlertTriangle className="w-5 h-5 text-orange-500" />
          ) : (
            <Coins className="w-5 h-5 text-sidebar-foreground" />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="px-8 mb-3">
      <div 
        className={`p-3 rounded-md border transition-colors ${
          isLowBalance() 
            ? 'bg-orange-50 dark:bg-orange-950 border-orange-200 dark:border-orange-800 hover:bg-orange-100 dark:hover:bg-orange-900' 
            : 'bg-sidebar border-sidebar-border hover:bg-sidebar-accent'
        }`}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {isLowBalance() ? (
              <AlertTriangle className="w-5 h-5 text-orange-500" />
            ) : (
              <Coins className="w-5 h-5 text-sidebar-foreground" />
            )}
            <span className="text-sm font-medium text-sidebar-foreground">
              {tokenBalance} tokens remaining
            </span>
          </div>
        </div>
        
        {/* Persistent Buy More Tokens Link */}
        <div className="mt-2">
          <button 
            onClick={onPurchaseClick}
            className="text-xs text-primary hover:text-primary/80 underline hover:no-underline transition-colors"
          >
            Buy more tokens
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenBalance;
